module.exports = __webpack_public_path__ + "img/Winner-1.ce391ac1.jpg";